import { useState } from "react";
import { toast } from "sonner";
import { Download, Upload, Layers } from "lucide-react";
import { GlassCard } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

export const HammaddeStok = () => {
  const [busy, setBusy] = useState(false);
  const [s, setS] = useState(null);
  const indir = async () => {
    try {
      const { data } = await api.get("/aktarim-hammadde/sablon", { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(data); a.download = "hammadde-acilis-stoku.xlsx"; a.click(); URL.revokeObjectURL(a.href);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const yukle = async (file) => {
    const fd = new FormData(); fd.append("dosya", file); setBusy(true);
    try {
      const { data } = await api.post("/aktarim-hammadde/stok", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setS(data); toast.success(`${data.girilen} hammaddeye stok girildi, ${data.fiyat_guncellenen} alış fiyatı güncellendi`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <GlassCard className="p-6 space-y-4" data-testid="hammadde-stok">
      <div className="flex items-center gap-2 font-medium"><Layers className="w-4 h-4" />Hamur, bez ve halka açılış stoku</div>
      <p className="text-xs text-muted-foreground">1) Şablonu indirin: tüm hammadde kartlarınız mevcut stoklarıyla listelenir. 2) "Sayılan Miktar" sütununa depodaki gerçek miktarı (kartın biriminde: hamur gr, bez cm, halka adet) yazın; isterseniz "Alış Fiyatı"nı da doldurun. 3) Yükleyin. Sayılan miktar ile mevcut stok arasındaki fark stoka girilir — aynı dosyayı tekrar yüklemek stoku iki kez artırmaz. Boş bırakılan satırlar atlanır. Alış fiyatları girilince ürün maliyetleri ve bayi fiyatları yeniden hesaplanır.</p>
      <div className="flex flex-wrap gap-3">
        <button onClick={indir} data-testid="hammadde-sablon" className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm border border-white/10 hover:bg-white/10"><Download className="w-4 h-4" />Hammadde şablonunu indir</button>
        <label className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm grad-bg text-white cursor-pointer ${busy ? "opacity-50 pointer-events-none" : ""}`} data-testid="hammadde-dosya-label">
          <Upload className="w-4 h-4" />{busy ? "Yükleniyor…" : "Doldurulmuş dosyayı yükle"}
          <input type="file" accept=".xlsx,.xls,.csv" className="hidden" data-testid="hammadde-dosya" onChange={(e) => { const f = e.target.files?.[0]; if (f) yukle(f); e.target.value = ""; }} />
        </label>
      </div>
      {s && (
        <div className="rounded-xl bg-white/[0.04] p-4 text-sm space-y-1" data-testid="hammadde-sonuc">
          <div>{s.girilen} stok girişi · {s.fiyat_guncellenen} fiyat güncellendi · {s.atlanan} satır atlandı{s.hatali ? ` · ${s.hatali} hatalı` : ""}</div>
          {s.hatalar?.map((h) => <div key={h.satir} className="text-xs text-red-300">Satır {h.satir}: {h.mesaj}</div>)}
        </div>
      )}
    </GlassCard>
  );
};
